import * as React from 'react';
import { styled } from '@glitz/react';
import { maxContentNormalWidthDecorator } from 'webapp/components/page-layout';
import { createMaxMobileViewportDecorator, createMinLargeViewportDecorator } from 'webapp/viewport';
import { ArticleCard } from './ArticleCard';
import { isSvenssons } from 'webapp/theme';

type PropType = {
  list: NordicNest.Api.ArticleListItemApiModel[];
  cardBackgroundColor?: string;
};
export const ArticleListing = styled((props: PropType) => {
  const gridDecorator = styled({
    gridTemplateColumns:
      props.list.length === 2 ? '1fr 1fr' : props.list.length === 3 ? '2fr 1fr 1fr' : 'repeat(4, 1fr)',
  });

  return (
    <Grid css={isSvenssons ? svenssonsGridDecorator : gridDecorator}>
      {props.list.map((article, index) => (
        <ArticleCard
          key={article.url}
          {...article}
          backgroundColor={props.cardBackgroundColor}
          useImageWrapper={!isSvenssons && (props.list.length === 2 || (props.list.length === 3 && index === 0))}
        />
      ))}
    </Grid>
  );
});

const Grid = styled.div(
  maxContentNormalWidthDecorator,
  createMinLargeViewportDecorator({
    gridColumnGap: t => (isSvenssons ? t.spacing.s : t.spacing.xl),
    gridRowGap: t => (isSvenssons ? t.spacing.m : t.spacing.xxl),
  }),
  {
    display: 'grid',
    gridColumnGap: t => (isSvenssons ? t.spacing.xs : t.spacing.s),
    gridRowGap: t => (isSvenssons ? t.spacing.xs : t.spacing.m),
  },
  !isSvenssons &&
    createMaxMobileViewportDecorator({
      display: 'flex',
      flexDirection: 'column',
      gap: t => t.spacing.m,
    }),
);

const svenssonsGridDecorator = styled(
  createMinLargeViewportDecorator({
    gridTemplateColumns: 'repeat(3,  minmax(0, 1fr))',
  }),
  createMaxMobileViewportDecorator({
    gridTemplateColumns: 'minmax(0, 1fr)',
  }),
  {
    gridTemplateColumns: 'repeat(2,  minmax(0, 1fr))',
  },
);
